<template>
  <el-form :model="form" size="mini" :rules="rules" ref="form" class="form-horizontal flex-column " label-width="200px" style="padding: 20px 0;">
    <div class="flex-row flex-wrap justify-content-between" v-if="(form.id+'').indexOf('ii_')<0">
      <el-form-item prop="itemBelong" label="检查类型：" style="width: 80%;">
        <el-radio-group v-model="form.itemBelongRadio" style="width: 100%;" @change="itemBelongChange">
          <div class="el-radios-div" >
            <el-radio :label="1" >
              <div>选择检查类型</div>
            </el-radio>
            <el-select :disabled="form.itemBelongRadio==2" v-model="form.itemBelong1" filterable clearable allow-create placeholder="请选择" class="flex-1" @change="itemBelongChange">
              <el-option v-for="(item,key) in longItemList" :key="'pr_'+key" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="el-radios-div" style="margin-top: 5px;">
            <el-radio :label="2" >
              <div>新增检查类型</div>
            </el-radio>
            <el-input :disabled="form.itemBelongRadio==1" placeholder="请填写检查类型名称" v-model="form.itemBelong2" class="required flex-1" @change="itemBelongChange">
            </el-input>
          </div>

          <el-input placeholder="" v-model="form.itemBelong" style="display: none;"></el-input>
        </el-radio-group>

      </el-form-item>
      <el-form-item prop="name" label="检查内容：" style="width: 80%;">
        <el-input type="textarea"
                  class="required"
                  placeholder="请填写"
                  v-model="form.name"
                  maxlength="300"
                  :rows="4"
                  show-word-limit>
        </el-input>
      </el-form-item>
    </div>
    <div v-else>
      <el-form-item prop="name" label="检查类型：" style="width: 80%;">
        <el-input placeholder="" v-model="form.name" class="required" >
        </el-input>
      </el-form-item>
    </div>
    <div class="flex-row flex-wrap justify-content-between">
      <el-form-item prop="status" label="启用/禁用：" style="width: 80%;">
        <el-switch
          v-model="form.status"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </el-form-item>
    </div>

    <div class="text-center p-t-sm" v-if="!isShow">
      <button class="btn btn-sm btn-primary btn-save" type="button" @click="submitForm" v-loading="submitLoading">确定</button>
      <button class="btn btn-sm btn-white btn-cancle" data-dismiss="modal">取消</button>
    </div>
  </el-form>
</template>

<script>
import {
  mapActions
}
from 'vuex'
export default {
  components: {},
  name: 'deptForm',
  props: {
    formType: {
      type: String,
      default: ''
    },
    longItemList: {
      type: Array,
      default: []
    },
    dept: {
      type: Object,
      default: null,
    },
    modalShow: {
      type: Boolean,
      default: false
    },
    isFill: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      submitLoading: false,


      form: {
        id:'',
        name: '',
        itemBelong: '',
        itemBelong1: '',
        itemBelong2: '',
        status:1,
        itemBelongRadio:1,
      },
      rules: {
        name: [{
          required: true,
          message: '必填项不能为空',
          trigger: 'blur'
        }],
        itemBelong:[{
          required: true,
          message: '必填项不能为空',
          trigger: ['change']
        }]
      },
    }
  },
  computed: {
  },
  watch: {
    modalShow(to) {
      this.$refs.form.resetFields()
      if (this.dept !== null) {
        this.form = {
          ...this.dept
        }
      }
    },
  },
  mounted() {
    if (this.dept !== null) {
      this.form = {
        ...this.dept
      }
    }
  },
  methods: {
    ...mapActions([
      'alertToggle',
      'fetchData'
    ]),
    saveItemType(){
      let url = 'ROOM.CHECKTASK_ITEM_TITLE_UPDATE';
      let formParams = {"itemBelong":this.form.name,"oldItemBelong":this.dept.name,status:this.form.status}
      let params = {
        params : JSON.stringify(formParams)
      }
      this.submitLoading = true
      this.fetchData({
        url,
        method: 'get',
        params,
        isLoading: false
      }).then(res => {
        this.$message.success('操作成功！')
        this.submitLoading = false
        this.$emit('success')
      }).catch(err => {
        this.submitLoading = false
      }).finally(()=>{
        this.submitLoading = false
      })
    },
    submitForm() {
      const _this = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          if((this.form.id+'').indexOf('ii_')>-1){
            this.saveItemType()
            return true
          }
          let url = 'ROOM.CHECKTASK_ITEM_SAVE';
          let formParams = {...this.form}
          let params = {
            params : JSON.stringify(formParams)
          }
          this.submitLoading = true
          this.fetchData({
            url,
            method: 'get',
            params,
            isLoading: false
          }).then(res => {
            this.$message.success('操作成功！')
            this.submitLoading = false
            this.$emit('success')
          }).catch(err => {
            _this.submitLoading = false
          }).finally(()=>{
            _this.submitLoading = false
          })
        }else{
          return false;
        }
      });
    },
    itemBelongChange(){
      if(this.form.itemBelongRadio==1){
        //this.form.itemBelong = this.form.itemBelong1
        this.$set(this.form,'itemBelong',this.form.itemBelong1)
      }else{
        //this.form.itemBelong = this.form.itemBelong2
        this.$set(this.form,'itemBelong',this.form.itemBelong2)
      }

    }
  }
}
</script>
<style lang="less" scoped>
  .el-radios-div{
    width: 100%;
    display: flex;
  }
  .el-radio{
    line-height: 30px;
    width: 100px;
    display: flex;
    /deep/ .el-radio__input{
      line-height: 30px;
    }
  }

</style>
